import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    searchParams: {
        id: "",
        supplier: null,
        date: "",
    }
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrderSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setOrderSearchParamsAction } = orderSlice.actions;
export default orderSlice;